import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Navigation, Pagination } from 'swiper/modules';
import bannerImg from "../../assets/img/administrator-banner.jpg";


const DashboardWelcome = () => {
    return (
        <div className="dashboard-welcome">
            <Swiper
                modules={[Navigation, Pagination]}
                spaceBetween={50}
                slidesPerView={1}
                navigation
                pagination={{ clickable: true }}
                loop={true}
            >
                <SwiperSlide>
                    <div className="slide-content">
                        <h1>Bienvenido al Dashboard de Gestión de Archivos</h1>
                        <p>
                            Aquí podrás administrar de forma sencilla y profesional todos los archivos de la plataforma.
                            Utiliza el menú de la izquierda para seleccionar una sección y comenzar a gestionar tus
                            recursos.
                        </p>
                        <p>
                            Podrás subir, editar, eliminar y organizar documentos, imágenes, videos y más, todo en un
                            solo lugar.
                        </p>
                        <p>
                            Si necesitas ayuda o más información, consulta la documentación o contacta con el equipo de
                            soporte.
                        </p>
                        <img src={bannerImg} alt="Promotional" className="slider-image" />
                    </div>
                </SwiperSlide>
            </Swiper>
        </div>
    );
};

export default DashboardWelcome;